import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const locale = sessionStorage.getItem('versant_locale') || 'en';

  const footerTranslations = {
    en: {
      rights: "All rights reserved.",
      terms: "Terms and Conditions",
      privacy: "Privacy Policy",
      refund: "Cancellation & Refunds",
      ebook: "Versant Test Mastery Ebook 📘",
      language: "Language:"
    },
    es: {
      rights: "Todos los derechos reservados.",
      terms: "Términos y Condiciones",
      privacy: "Política de Privacidad",
      refund: "Cancelación y Reembolsos",
      ebook: "eBook de Maestría Versant 📘",
      language: "Idioma:"
    },
    pt: {
      rights: "Todos os direitos reservados.",
      terms: "Termos e Condições",
      privacy: "Política de Privacidade",
      refund: "Políticas de Reembolso",
      ebook: "eBook de Maestria Versant 📘",
      language: "Idioma:"
    },
    ja: {
      rights: "All rights reserved.",
      terms: "利用規約",
      privacy: "プライバシーポリシー",
      refund: "返金ポリシー",
      ebook: "Versant対策電子書籍 📘",
      language: "言語:"
    }
  };

  const f = footerTranslations[locale] || footerTranslations.en;

  const handleLocaleClick = (targetLocale) => {
    sessionStorage.setItem('versant_locale', targetLocale);
    window.scrollTo(0, 0);
    const scrollableElements = document.querySelectorAll('.overflow-auto, .overflow-y-auto');
    scrollableElements.forEach(el => {
      el.scrollTop = 0;
    });
  };

  return (
    <footer className="bg-green-800 text-white py-6 px-4">
      <div className="container mx-auto text-center text-sm space-y-3">
        <p>© {new Date().getFullYear()} Versant Test. {f.rights}</p>
        <div className="flex flex-wrap justify-center items-center gap-y-2">
          <Link to="/versant-speaking-and-listening-practice-test" className="hover:text-green-200 mx-2 font-medium">Speaking & Listening</Link>
          <Link to="/versant-reading-and-writing-mock-test" className="hover:text-green-200 mx-2 font-medium">Reading & Writing</Link>
          <Link to="/versant-vept-mock-test" className="hover:text-green-200 mx-2 font-medium">VEPT Mock Test</Link>
          <Link to="/versant-test-for-tcs" className="hover:text-green-200 mx-2 font-medium">TCS Versant Test</Link>
          <Link to="/versant-test-for-amazon" className="hover:text-green-200 mx-2 font-medium">Amazon Versant Test</Link>
          <Link to="/versant-test-for-cognizant" className="hover:text-green-200 mx-2 font-medium">Cognizant Versant Test</Link>
          <Link to="/terms" className="hover:text-green-200 mx-2">{f.terms}</Link>
          <Link to="/privacy" className="hover:text-green-200 mx-2">{f.privacy}</Link>
          <Link to="/refund" className="hover:text-green-200 mx-2">{f.refund}</Link>
          <Link to="/ebook" className="font-extrabold text-amber-400 hover:text-amber-300 mx-2 drop-shadow-md">{f.ebook}</Link>
        </div>

        {/* Language Switcher */}
        <div className="pt-2 border-t border-green-700/60 flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-xs text-green-100">
          <span className="font-semibold text-green-200">{f.language}</span>
          <Link
            to="/"
            onClick={() => handleLocaleClick('en')}
            className={`hover:text-white transition-colors cursor-pointer ${locale === 'en' ? 'font-bold text-amber-300 underline' : 'text-green-200/90'}`}
          >
            English
          </Link>
          <span className="text-green-600">•</span>
          <Link
            to="/es"
            onClick={() => handleLocaleClick('es')}
            className={`hover:text-white transition-colors cursor-pointer ${locale === 'es' ? 'font-bold text-amber-300 underline' : 'text-green-200/90'}`}
          >
            Español
          </Link>
          <span className="text-green-600">•</span>
          <Link
            to="/ja"
            onClick={() => handleLocaleClick('ja')}
            className={`hover:text-white transition-colors cursor-pointer ${locale === 'ja' ? 'font-bold text-amber-300 underline' : 'text-green-200/90'}`}
          >
            日本語
          </Link>
          <span className="text-green-600">•</span>
          <Link
            to="/pt"
            onClick={() => handleLocaleClick('pt')}
            className={`hover:text-white transition-colors cursor-pointer ${locale === 'pt' ? 'font-bold text-amber-300 underline' : 'text-green-200/90'}`}
          >
            Português
          </Link>
        </div>

        {/* Legal Trademark Disclaimer */}
        <p className="text-[11px] text-green-200/70 max-w-4xl mx-auto pt-2 leading-relaxed font-light border-t border-green-700/40 mt-3">
          Disclaimer: Versant™ is a registered trademark of Pearson Education, Inc. VersantPro is an independent test preparation platform & simulator. VersantPro is not affiliated with, sponsored by, or endorsed by Pearson Education, Inc.
        </p>
      </div>
    </footer>
  );
}
